<div class="item-list">
  @if (label) {
    <label class="item-list__label">{{ label }}</label>
  }

  @for (row of rows; track row; let i = $index) {
    <div class="item-list__row">
      <div class="item-list__row-fields">
        <app-dynamic-form
          [formProperties]="rowProperties"
          [formGroup]="row"
        ></app-dynamic-form>
      </div>
      <sui-button
        size="xsm"
        variant="danger"
        [leadingIcon]="['fas', 'circle-xmark']"
        [iconOnly]="true"
        ariaLabel="Remove"
        (click)="removeRow(i)"
      ></sui-button>
    </div>
  }

  <sui-button
    variant="secondary"
    [leadingIcon]="['fas', 'plus']"
    (click)="addRow()"
  >
    {{ addLabelKey | translate }}
  </sui-button>
</div>
